// models
import { AvailableMedicalService } from '../../../../models/Entities/MedicalServices/AvailableMedicalService';
import { AppState } from '../../../../redux/reducers';

export interface IProps {
  onSelectedServices: (services: AvailableMedicalService[] | undefined) => void;
  MedicalServicesSelectedIds: number[] | undefined;
  MultiselectEnable: boolean;
  noteText?: string;
  /** Etiqueta del campo (por defecto "Seleccione una práctica médica"). */
  label?: string;
  disabled?: boolean;
}

interface ConnectedProps {
  /** Catálogo completo si otra pantalla ya lo cargó; si está vacío, el selector busca en el servidor. */
  CatalogServices: AvailableMedicalService[];
  isCatalogLoading: boolean;
  access_token: string | undefined;
}

export type Props = IProps & ConnectedProps;

export const mapStateToProps = (state: AppState, _ownProps: IProps) => ({
  CatalogServices: state.MedicalServices?.list ?? [],
  isCatalogLoading: !!state.MedicalServices?.isLoadingAll,
  access_token: state.oidc?.user?.access_token
});

export const mapDispatchToProps = {};

export const GetMedicalServiceById = (
  medicalServiceId: number,
  medicalServices: AvailableMedicalService[]
): AvailableMedicalService | undefined => medicalServices.find((item) => item.id === medicalServiceId);
